/* Nu atinge localStorage: singura lui sursa e window.amphrFavorites. */
(function () {
  'use strict';

  if (!window.amphrFavorites) return;

  var SEL = '[data-fav-btn]';
  var last = [];

  function paint(btn, items) {
    var handle = btn.getAttribute('data-fav-handle');
    var active = items.indexOf(handle) !== -1;
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', btn.getAttribute(active ? 'data-label-on' : 'data-label-off') || '');
    btn.removeAttribute('data-fav-pending');
  }

  function paintAll(items, onlyPending) {
    var sel = onlyPending ? SEL + '[data-fav-pending]' : SEL;
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (btn) {
      paint(btn, items);
    });
    /* Doar la schimbare de stare, nu si la trecerea onlyPending (butoane injectate
       async): un contor din header nu soseste niciodata in starea `pending`. */
    if (!onlyPending) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fav-count]'), function (el) {
        el.textContent = items.length;
        el.hidden = items.length === 0;
        var link = el.closest('[data-fav-label-base]');
        if (link) {
          var base = link.getAttribute('data-fav-label-base') || '';
          link.setAttribute('aria-label', items.length > 0 ? base + ' (' + items.length + ')' : base);
        }
      });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;
    /* Butonul de pe card sta intr-un <a>; fara asta clickul deschide produsul. */
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-fav-handle');
    if (handle) window.amphrFavorites.toggle(handle);
  });

  window.amphrFavorites.subscribe(function (items) {
    last = items;
    paintAll(items, false);
  });

  /* Cardurile injectate async (overlay de cautare, recomandari, pagina
     Favorites) sosesc cu butonul in starea server: pending. */
  new MutationObserver(function () {
    paintAll(last, true);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
